import Skeleton from "@mui/material/Skeleton";

import { IconSkeleton } from "./Article";

export default function Comments() {
	return (
		<div>
			<IconSkeleton />
			<Skeleton variant="rounded" height={40} />
			<Skeleton variant="text" height={10} />
			<Skeleton variant="rounded" height={40} />
			<Skeleton variant="text" height={10} />
			<Skeleton variant="rounded" height={60} />
		</div>
	);
}
